/**
 * @generated SignedSource<<0afdbc515dfbc24a35644e69cd9a209d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSubmissionsTable_QueryFragment$data = {
  readonly Admin: {
    readonly LearnV2: {
      readonly GetContentSubmissions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionsTable_ContentSubmissionFragment">;
          };
        } | null | undefined> | null | undefined;
      };
    };
  };
  readonly " $fragmentType": "ContentSubmissionsTable_QueryFragment";
};
export type ContentSubmissionsTable_QueryFragment$key = {
  readonly " $data"?: ContentSubmissionsTable_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionsTable_QueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "treeStateId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentSubmissionsTable_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LearnV2AdminSchema",
          "kind": "LinkedField",
          "name": "LearnV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 100
                },
                {
                  "kind": "Variable",
                  "name": "treeStateId",
                  "variableName": "treeStateId"
                }
              ],
              "concreteType": "ContentSubmissionsConnection",
              "kind": "LinkedField",
              "name": "GetContentSubmissions",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentSubmissionsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContentSubmission",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "ContentSubmissionsTable_ContentSubmissionFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "LastUpdatedAtColumn_ContentSubmissionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "StartedAtColumn_ContentSubmissionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ProjectRewardsColumn_ContentSubmissionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "RootNodeTitleColumn_ContentSubmissionFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "StatusColumn_ContentSubmissionFragment"
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3a72a6537114bd5b22781cafafc8eb66";

export default node;
